import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'since'
})
export class SincePipe implements PipeTransform {

  transform(value: string): string {
      const now = new Date();
      const date = new Date(value);
      const a = moment([now.getFullYear(), now.getMonth(), now.getDate()]);
      const b = moment([date.getFullYear(), date.getMonth(), date.getDate()]);
      const differentInDays = a.diff(b, 'days');

      if (differentInDays < 1) {
          return `Today`;
      }

      if (value == null) {
          return `N/A`;
      }

      if (differentInDays > 1) {
          return `${differentInDays} days ago`;
      }

      return `a day ago`;
  }

}
